import { useRevalidator } from 'react-router';
import { useCallback, useMemo } from 'react';

export const useDataRefresh = () => {
    const { revalidate, state } = useRevalidator();

    // Returns the revalidation promise so callers can tell the Business Manager
    // when the preview has actually caught up — `refreshDone` used to fire on
    // the same tick the refresh started, which left the parent with no way to
    // show progress.
    const refresh = useCallback(() => revalidate(), [revalidate]);

    return useMemo(() => {
        return { refresh, state };
    }, [refresh, state]);
};
